<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/api/sys/messageRecode"
    import download from '@/utils/download'
    let isDelete = {"1":"正常数据","2":"禁用"};
    let codeStatus = {"0":"未使用","1":"已使用","2":"已失效","3":"发送失败"};
    let smsTunnel = {"-1":"伪短信","1":"LW","2":"HYT","3":"MXT(国内)","4":"JD","5":"MXT(国际)","6":"ZZ","7":"ten_cent"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if("手动生成验证码" == clickName){
                    this.$refs.childUpdate.open();
                }else if("下载" == clickName){
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
                    download.exportExcel(Url.export,param,"短信验证码记录");
                }else if("导出" == clickName){
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:false});
                    download.exportExcel(Url.export,param,"短信验证码记录");
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                model.params = {sign:"test",code:model.params};
                this.dataChanage(Url.sendFake,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: 'nationCode', field: 'nationCode',hidden:true,data:86},
                        { title: '手机号', field: 'phone'},
                        { title: '验证码', field: 'params'},
                        { title: '模板编码', field: 'tempCode',type:2,data:[],required:true},
                    ]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: '手机号', field: 'phone'},
                        { title: '数据状态', field: 'codeStatus',type: 2,optionList:codeStatus},
                        { title: '开始时间', field: 'startDate',type: 5,format:'yyyy-MM-dd HH:mm:ss'},
                        { title: '结束时间', field: 'endDate',type: 5,format:'yyyy-MM-dd HH:mm:ss'},
                        {click:"查询"},
                        {click:"手动生成验证码"},
                        {click:"下载",auth:"sys:messageRecode:down"},
                        {click:"导出",auth:"sys:messageRecode:export"},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.queryUrl,
                    selection: false,
                    sequence: true,
                    cols: [
                        { title: '日期', field: 'createDate'},
                        { title: '发送通道', field: 'receiveTunnel',render:(data)=>{
                                return smsTunnel[data];
                            }},
                        { title: '内容', field: 'content'},
                        { title: 'code', field: 'code'},
                        { title: '手机号', field: 'phone',render:(data)=>{
                                if(data){
                                    return data.replace(/(\d{3})\d{3}(\d{3})/, "$1***$2");
                                }
                            }},
                        { title: '验证码状态', field: 'codeStatus',render:(data)=>{
                            return codeStatus[data];
                            }},
                        { title: '数据状态', field: 'isDelete',render:(data,full)=>{
                                return isDelete[data];
                            }},
                    ]
                }
            }
        },
        mounted() {
            this.$axios.get(Url.getTemplateCode).then(res =>{
                if (res.code == 0) {
                    let list=res.result;
                    this.updateData.cols =[
                        { title: 'nationCode', field: 'nationCode',hidden:true,data:86},
                        { title: '手机号', field: 'phone'},
                        { title: '验证码', field: 'params'},
                        { title: '模板编码', field: 'tempCode',type:2,data:[],optionList:list,required:true},
                    ]
                }
            });
        }
    }
</script>
